import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';

const TransferWorkLoadLazy = React.lazy(
	() =>
		import(
			/* webpackChunkName : 'TransferWorkLoad' */ './components/TransferWorkLoad'
		)
);

export default (store) => {
	return {
		path: 'staff-setup/:campusId?/transfer-work-load/:id',
		element: (
			<AsyncLoading
				component={
					<TransferWorkLoadLazy permission="CanManageAdmissionSetup" />
				}
			/>
		),
	};
};
